module.exports = __webpack_public_path__ + "img/ico017.ba67a0e7.svg";